'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function BusListController($scope, $window, $filter, BusComponent, PageHeading, Toast, Line) {
	'ngInject';

	var vm = this;

	vm.getBuses = BusComponent.getBuses;
	vm.deleteBus = deleteBus;
	vm.copyBus = copyBus;
	vm.openEditForm = openEditForm;
	vm.openCreateForm = openCreateForm;
	vm.createEditBus = createEditBus;
	vm.updateDays = updateDays;
	vm.updateCheckAllCheckbox = updateCheckAllCheckbox;
	vm.bus = {};
	vm.points = [];
	vm.days = [{
		'name': $filter('translate')('WEEK_DAYS.MONDAY'),
		'checked': 0
	}, {
		'name': $filter('translate')('WEEK_DAYS.TUESDAY'),
		'checked': 0
	}, {
		'name': $filter('translate')('WEEK_DAYS.WEDNESDAY'),
		'checked': 0
	}, {
		'name': $filter('translate')('WEEK_DAYS.THURSDAY'),
		'checked': 0
	}, {
		'name': $filter('translate')('WEEK_DAYS.FRIDAY'),
		'checked': 0
	}, {
		'name': $filter('translate')('WEEK_DAYS.SATURDAY'),
		'checked': 0
	}, {
		'name': $filter('translate')('WEEK_DAYS.SUNDAY'),
		'checked': 0
	}];

	activate();

	function activate() {
		var heading = $filter('translate')('BUSES_FROM_LINE') + ' ' + Line.translation.name;
		var title = 'BTMS | ' + $filter('translate')('SIDEBAR.BUSES');

		PageHeading.setPageHeading(heading, title);
	}

	function deleteBus(id) {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			BusComponent.deleteBus(id).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.DELETE_BUS'));
					BusComponent.fetchBuses(Line.id);
					vm.showAddEditForm = false;
				}
			});
		}
	}

	function openEditForm(bus) {
		// Clear the form
		$scope.addEditBusForm.$setPristine();
		vm.bus = bus;
		// Fill the canvas with the stations and redraw
		addCanvasStations(bus.stations, Line.stations);
		// Update the days
		updateDays(bus.days);
		// Show the add / edit bus form
		vm.showAddEditForm = true;
	}

	function openCreateForm() {
		// Clear the form
		$scope.addEditBusForm.$setPristine();
		vm.bus = {};
		// Fill the canvas with the stations and redraw
		addCanvasStations(Line.stations);
		// Clear the days
		updateDays();
		// Show the add / edit bus form
		vm.showAddEditForm = true;
	}

	function updateDays(checkedDays, checkAll, event) {
		if (checkedDays === undefined) checkedDays = [];
		if (checkAll === undefined) checkAll = false;

		if (event) {
			event.preventDefault();
		}
		// Clear the days checkboxes
		vm.isAnyDayChecked = false;
		vm.days.forEach(function (day) {
			day.checked = 0;
		});

		// Update the boxed according to the bus days
		if (checkedDays.length) {
			checkedDays.forEach(function (day) {
				vm.days[typeof day.day === 'undefined' ? day : day.day].checked = 1;
			});
			updateCheckAllCheckbox();
			// Check all boxes
		} else if (checkAll) {
				vm.days.forEach(function (day) {
					day.checked = 1;
				});
				vm.isAnyDayChecked = true;
				vm.checkAllDays = true;
				// Leave all boxes unchecked
			} else {
					vm.checkAllDays = false;
				}
	}

	function updateCheckAllCheckbox() {
		vm.isAnyDayChecked = false;
		var allChecked = true;
		// Check if there is any unchecked box
		vm.days.forEach(function (value) {
			if (!value.checked) {
				allChecked = false;
			} else {
				vm.isAnyDayChecked = true;
			}
		});

		vm.checkAllDays = allChecked;
	}

	// Create or edit a bus
	function createEditBus(id, seats, stations, days) {
		// Validate the current form
		var isValidForm = validateFormData(seats, stations);
		if (!isValidForm) {
			return false;
		}

		// Save the data from the current form
		var params = buildBusDataObject(id, seats, stations, days);

		// Send request for update / create
		if (id) {
			BusComponent.updateBus(id, params).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					vm.showAddEditForm = false;
					Toast.success($filter('translate')('SUCCESS.UPDATE_BUS'));
					BusComponent.fetchBuses(Line.id);
				}
			});
		} else {
			BusComponent.createBus(params).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					vm.showAddEditForm = false;
					Toast.success($filter('translate')('SUCCESS.CREATE_BUS'));
					BusComponent.fetchBuses(Line.id);
				}
			});
		}
	}

	/**
  * Validates the current direction form
  *
  * @param {Number} seats
  * @param {Array} stations
  * @returns {Boolean} - true if validation passes
  */
	function validateFormData(seats, stations) {
		var hasErrors = false;

		angular.forEach($scope.addEditBusForm.$error.required, function () {
			hasErrors = true;

			return false;
		});

		if (hasErrors || $scope.addEditBusForm.seats.$error.min || !vm.isAnyDayChecked) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		var timeValidationPasses = true;
		// Add stations
		stations.forEach(function (station, index) {
			// Validate the hours
			if (index !== 0 && !validateTime(station.arrives_in)) {
				station.arrives_in = '';
				timeValidationPasses = false;
			}

			if (index !== stations.length - 1 && !validateTime(station.departure_in)) {
				station.departure_in = '';
				timeValidationPasses = false;
			}
		});

		if (!timeValidationPasses) {
			Toast.error($filter('translate')('ERRORS.VALID_HOUR'));

			return false;
		}

		return true;
	}

	/**
  * Builds the bus data object to send to the API
  *
  * @param {Number} id
  * @param {Number} seats
  * @param {Array} stations
  * @param {Array} days
  * @returns {Object}
  */
	function buildBusDataObject(id, seats, stations, days) {
		var bus = {
			'id': id,
			'line_id': Line.id,
			'seats': seats,
			'stations': [],
			'days': []
		};

		stations.forEach(function (station) {
			bus.stations.push({
				'station_id': station.station.id,
				'arrives_in': station.arrives_in ? station.arrives_in.substr(0, 2) + ':' + station.arrives_in.substr(2, 4) : '',
				'departure_in': station.departure_in ? station.departure_in.substr(0, 2) + ':' + station.departure_in.substr(2, 4) : ''
			});
		});

		// Add days to bus data object
		days.forEach(function (day, index) {
			if (day.checked) {
				bus.days.push(index);
			}
		});

		return bus;
	}

	/**
  * Validates the given time from an input
  *
  * @param {String} time
  * @returns {Boolean}
  */
	function validateTime(time) {
		// Validate against the right pattern
		if (!/^\d{2}\d{2}$/.test(time)) {
			return false;
		}

		// Get hours and minutes
		var hour = parseInt(time.substr(0, 2), 10);
		var minutes = parseInt(time.substr(2, time.length), 10);

		// Check hours range
		if (hour < 0 || hour > 23) {
			return false;
		}

		// Check minutes range
		if (minutes < 0 || minutes > 59) {
			return false;
		}

		return true;
	}

	/**
  * Add stations to canvas and redraw the canvas
  *
  * @param {Array} stations
  */
	function addCanvasStations(stations) {
		var lineStations = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

		vm.points = buildStationsArray(stations, lineStations);
		vm.redraw(vm.points);
	}

	/**
  * Builds a station array to use for the canvas
  *
  * @param {Array} stations
  * @return {Array}
  */
	function buildStationsArray(stations, lineStations) {
		var buildStations = [];
		var arrivesIn = '';
		var departureIn = '';

		stations.forEach(function (station) {
			if (station.pivot) {
				arrivesIn = station.pivot.arrives_in ? '' + station.pivot.arrives_in.substr(0, 2) + station.pivot.arrives_in.substr(3, 5) : '';
				departureIn = station.pivot.departure_in ? '' + station.pivot.departure_in.substr(0, 2) + station.pivot.departure_in.substr(3, 5) : '';
			}

			buildStations.push({
				'name': station.city.translation.name,
				'arrives_in': arrivesIn,
				'departure_in': departureIn,
				'station': {
					'id': station.id,
					'name': station.translation.name
				},
				'position': lineStations.length ? _lodash2['default'].result(_lodash2['default'].find(lineStations, 'id', station.id), 'pivot').position : station.pivot.position
			});
		});

		buildStations = _lodash2['default'].sortBy(buildStations, 'position');

		return buildStations;
	}

	// Copy selected bus
	function copyBus(bus) {
		// Hide the create / edit form if any
		vm.showAddEditForm = false;
		// Fill the vm.point array with data
		addCanvasStations(bus.stations, Line.stations);
		// Fill the vm.days array with data
		updateDays(bus.days);

		var params = buildBusDataObject(null, bus.seats, vm.points, vm.days);

		BusComponent.createBus(params).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				vm.showAddEditForm = false;
				Toast.success($filter('translate')('SUCCESS.COPY_BUS'));
				BusComponent.fetchBuses(Line.id);
			}
		});
	}
}

exports['default'] = BusListController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/buses/list/list.controller.js
 **/